export enum AmountAggregatorOperatorType {
Addition,
Subtraction,
}
